<template>
  <section>
    <form class="form form__warehouses--add-order-products" autocomplete="off" @submit.prevent="perform">
      <b-field label="Fornitore *">
        <b-select placeholder="Seleziona il fornitore"
                  icon="store"
                  v-model="chosenSupplierId"
                  @change.native="loadSupplierOrderedProducts">
          <option v-for="supplier in suppliers"
                  :key="supplier.id"
                  :value="supplier.id"> {{ supplier['company-name'] }} </option>
        </b-select>
      </b-field>
      <div class="field is-grouped">
        <suggest
          :disabled="disableSku"
          label="Codice"
          :model="product.sku"
          placeholder="0303AB.4040"
          prop="sku"
          :list="inventory"
          @choosed="skuSuggestCallback"></suggest>
        <suggest
          :disabled="disableDescription"
          :expanded="true"
          label="Descrizione"
          :model="product.description"
          placeholder="GUARNIZIONE PER RACCORDO DIN DN 80"
          prop="description"
          :list="inventory"
          @choosed="descriptionSuggestCallback"></suggest>
        <div class="control is-clearfix">
          <label class="label">Quantità ordinata</label>
          <input v-model="product['confirmed-quantity']" class="input" type="number" disabled>
        </div>
        <div class="control is-clearfix">
          <label class="label">Quantità</label>
          <input v-model="product.quantity" step="0.01" min="0" max="999999.99"
                 type="number" class="input" placeholder="10.00"/>
        </div>
        <div class="control is-clearfix">
          <label class="label">Prezzo (€)</label>
          <input v-model="product.price" step="0.01" min="0" max="999999.99"
                 type="number" class="input" placeholder="10.00"/>
        </div>
        <div class="control">
          <div class="label is-unselectable">&nbsp;</div>
          <button class="button is-primary is-normal" @click.stop.prevent="add()" type="button">
            <b-icon icon="plus"></b-icon>
          </button>
        </div>
      </div>

      <table-component v-if="products.length" :show-filter="false" :data="products"
                       sort-by="description" sort-order="asc" :show-caption="false">
        <table-column label="Codice" show="sku"></table-column>
        <table-column label="Descrizione" show="description"></table-column>
        <table-column label="Quantità" show="quantity">
          <template slot-scope="row">
            <b-input v-model="row.quantity" step="0.01" min="0" max="999999.99" type="number"></b-input>
          </template>
        </table-column>
        <table-column label="Prezzo (€)" show="price">
          <template slot-scope="row">
            <b-input v-model="row.price" step="0.01" min="0" max="999999.99" type="number"></b-input>
          </template>
        </table-column>
        <table-column label="Stato" show="status">
          <template slot-scope="row">
            <section>
              <div class="block">
                <b-radio v-model="row.status" native-value="accepted">Accettato</b-radio>
                <b-radio v-model="row.status"
                         native-value="with-reservation"
                         @input="addNote($event, row)">Con Riserva
                </b-radio>
                <b-radio v-model="row.status"
                         native-value="not-accepted"
                         @input="addNote($event, row)">Non Accettato
                </b-radio>


                <p v-show="row.note.length > 0">
                  <b-field label="Nota:">
                    <b-input type="text"
                             icon="minus-circle"
                             :value="row.note"
                             @click.native="() => { row.note = ''; row.status = null; }" disabled></b-input>
                  </b-field>
                </p>
              </div>
            </section>
          </template>
        </table-column>
        <table-column label="Azioni" :sortable="false">
          <template slot-scope="row">
            <a title="Elimina"
               @click.prevent="remove(row.sku)">
              <b-icon type="is-primary" icon="trash"></b-icon>
            </a>
          </template>
        </table-column>
      </table-component>

      <button class="button is-primary" :disabled="products.length === 0" type="submit">Conferma</button>
    </form>
  </section>
</template>

<script>
  import {api, utils} from '../../../helpers'
  import Suggest from '../../actions/Suggest'

  export default {
    name: 'AddOrderRequestComponent',
    components: {Suggest},
    props: {
      role: {
        type: String,
        required: true
      },
      warehouseId: {
        type: Number,
        required: true
      },
      ddtCode: {
        required: true,
        // Custom validator
        validator: prop => typeof prop === 'string' || prop === null
      },
      ddtType: {
        required: true,
        validator: prop => typeof prop === 'string' || prop === null
      },
      ddtDate: {
        required: true,
        validator: prop => typeof prop === 'object'
      }
    },
    data () {
      return {
        suppliers: [],
        inventory: [],
        products: [],
        product: {
          id: null,
          sku: null,
          description: null,
          quantity: null,
          price: null,
          'confirmed-quantity': null,
          status: null, // { accepted, not-accepted, with-reservation }
          note: ''
        },
        disableSku: false,
        disableDescription: false,
        chosenSupplierId: ''
      }
    },
    methods: {
      skuSuggestCallback (sku) {
        let item = utils.objectByKey(this.inventory, 'sku', sku)
        if (item) {
          this.product.id = item.id
          this.product.sku = item.sku
          this.product.description = item.description
          this.product['confirmed-quantity'] = item['confirmed-quantity']
          this.disableDescription = true
        } else {
          this.product.id = 0
          this.product.sku = sku
          this.product.description = this.product.description || ''
          this.product['confirmed-quantity'] = ''
          this.disableDescription = false
        }
      },
      descriptionSuggestCallback (description) {
        let item = utils.objectByKey(this.inventory, 'description', description)
        if (item) {
          this.product.id = item.id
          this.product.sku = item.sku
          this.product.description = item.description
          this.product['confirmed-quantity'] = item['confirmed-quantity']
          this.disableSku = true
        } else {
          this.product.id = 0
          this.product.sku = this.product.sku || ''
          this.product.description = description
          this.product['confirmed-quantity'] = ''
          this.disableSku = false
        }
      },
      add () {
        // we cannot add a product sku not present in inventory
        if (utils.objectByKey(this.inventory, 'sku', this.product.sku) === null) {
          utils.errors(['Il prodotto non presente tra gli ordini.'])
          return false
        }

        if (utils.objectByKey(this.products, 'sku', this.product.sku) || false) {
          utils.errors(['Il prodotto selezionato è già stato aggiunto.'])
          return false
        }

        if (!this.product.sku || this.product.sku.length === 0) {
          utils.errors(['Inserire il codice del prodotto.'])
          return false
        }

        if (!this.product.description || this.product.description.length === 0) {
          utils.errors(['Inserire la descrizione del prodotto.'])
          return false
        }

        if (!this.product.quantity || this.product.quantity === 0) {
          utils.errors(['Inserire la quantità del prodotto.'])
          return false
        }

        this.disableDescription = false
        this.disableSku = false
        if (this.product.quantity === this.product['confirmed-quantity']) {
          this.product.status = 'accepted'
        }
        this.products.push(utils.copy(this.product))
        this.product = utils.reset(this.product)
      },
      remove (sku) {
        this.products.splice(utils.indexOfObject(this.products, 'sku', sku), 1)
      },
      loadSupplierOrderedProducts (event) {
        const modal = this.$loading.open()
        const supplierId = this.suppliers[event.target.selectedIndex - 1].id
        // on supplier change clean inventory and products
        this.inventory = []
        this.products = []
        api.getSupplierOrderedProducts(this.warehouseId, supplierId)
          .then(response => {
            if (typeof response === 'undefined') {
              utils.errors(['Non ci sono prodotti in consegna per questo fornitore.'])
              this.inventory = []
            } else {
              this.inventory = response
            }
            modal.close()
          })
          .catch(errors => utils.errors(errors, modal))
      },
      addNote (event, product) {
        if (event === 'with-reservation' || event === 'not-accepted') {
          utils.prompt(
            'Inserisci il motivo:',
            note => { // onConfirm
              product.note = note
            },
            () => {
              product.note = ''
              product.status = null
            }, // onCancel
            { // inputAttrs
              type: 'text',
              placeholder: 'Motivo',
              maxlength: 64
            }
          )
        }
      },
      perform () {
        if (!this.chosenSupplierId) {
          utils.errors(['Selezionare il fornitore'])
          return false
        }
        if (!this.ddtCode) {
          utils.errors(['Inserire il codice DDT.'])
          return false
        }
        if (!this.ddtDate) {
          utils.errors(['Inserire la data del DDT.'])
          return false
        }
        if (!this.ddtType) {
          utils.errors(['Inserire la tipologia del DDT.'])
          return false
        }

        let filtered = this.products.filter(item => item.status === null)
        if (filtered.length !== 0) {
          utils.errors(['Tutti i prodotti debbono avere lo stato valorizzato.'])
          return false
        }

        filtered = this.products.filter(item => {
          return item.status === 'not-accepted' || item.status === 'with-reservation'
            ? item.note.length === 0 : false
        })
        if (filtered.length > 0) {
          utils.errors(['Esistono prodotti "Accettati con riserva" o "Non Accettati" senza nota.'])
          return false
        }

        utils.confirm('Aggiungere i prodotti in magazzino?', () => {
          const modal = this.$loading.open()
          const ddtDate = utils.formatDateToYmd(this.ddtDate, '-')
          api.addOrderedProductsToWarehouse(this.warehouseId, this.chosenSupplierId, this.ddtCode, ddtDate, this.products)
            .then(() => {
              utils.success('Prodotti aggiunti con successo.', modal)
              this.$router.replace({name: `Warehouses`, params: {estateId: this.estateId}})
            })
            .catch(errors => utils.errors(errors, modal))
        })
      }
    },
    created: function () {
      const modal = this.$loading.open()
      api.getSuppliers()
        .then(response => {
          this.suppliers = response
          modal.close()
        })
        .catch(errors => utils.errors(errors, modal))
    },
    watch: {
      'product.sku': function (newer, older) {
        if (newer === '') {
          this.disableDescription = false
        }
      },
      'product.description': function (newer, older) {
        if (newer === '') {
          this.disableSku = false
        }
      },
      'product.quantity': function (newer, older) {
        this.product.quantity = newer === 0 ? null : parseFloat(newer)
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-component {
    margin-bottom: 2em;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/warehouses/AddOrderRequestComponent.vue